module.exports = __webpack_public_path__ + "img/3c9a3ce.jpg";